document.addEventListener("DOMContentLoaded", function() {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const productsContainer = document.querySelector(".tab-products");

  tabButtons.forEach(button => {
    button.addEventListener("click", function() {
      // Remove active state from all buttons
      tabButtons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      const handle = this.dataset.handle;

      // Fetch products via AJAX
      fetch(`/collections/${handle}?view=ajax-products`)
        .then(res => res.text())
        .then(html => {
          productsContainer.innerHTML = html;
        })
        .catch(err => console.error('Error loading collection:', err));
    });
  });
});
